import React from 'react';

const TimelineContext = React.createContext();

export default TimelineContext;
